import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CartService } from '../../services/cart.service';
import { DownloadModalService } from '../../services/download-modal.service';
import { ApiService } from '../../services/api.service';
import { environment } from '../../../environments/environment';

const BASE_URL = environment.apiUrl;

@Component({
  selector: 'app-viewalltemplate',
  templateUrl: './viewalltemplate.component.html',
  styleUrls: ['./viewalltemplate.component.css']
})
export class ViewalltemplateComponent implements OnInit, OnDestroy {
  templates: any[] = [];
  packageId: string | null = null;
  cartCount = 0;
  private sub?: Subscription;
  private routeSub?: Subscription;

  constructor(
    private cartService: CartService,
    private router: Router,
    private downloadModal: DownloadModalService,
    private route: ActivatedRoute,
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.sub = this.cartService.items$.subscribe(items => {
      this.cartCount = items.length;
    });

    this.routeSub = this.route.params.subscribe(params => {
      this.packageId = params['id'];
      this.fetchTemplates();
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.routeSub?.unsubscribe();
  }

  fetchTemplates() {
    this.apiService.fetchTemplates(this.packageId).subscribe({
      next: (res) => {
        if (res.status) {
          this.templates = res.data.map((t: any) => ({ ...t,title: t.name,image: `${BASE_URL}/uploads/template_images/${t.template_image}`}));
        }
      },
      error: (err) => {
        console.error('Error fetching templates:', err);
      }
    });
  }

  toggleCart(template: any) {
    if (this.cartService.has(template.id)) {
      this.cartService.remove(template.id);
    } else {
      this.cartService.add({
        id: template.id,
        title: template.title,
        image: template.image,
        description: template.description,
        price: template.price
      });
    }
  }

  isInCart(id: number): boolean {
    return this.cartService.has(id);
  }

  goToCart(): void {
    this.router.navigate(['/cart']);
  }

  openDownload(): void {
    this.downloadModal.open();
  }
}


